import Meta from '@components/Meta';
import { OurAttitudeToFood } from '../components/OurStory/OurAttitudeToFood';
import { WhyWeStarted } from '@components/OurStory/WhyWeStarted';
import { ProgrammeStatistics } from '../components/OurStory/ProgrammeStatistics';
import { WeAreHiring } from '@components/OurStory/WeAreHiring';
import { OurStoryHero } from '../components/OurStory/OurStoryHero';
import { Footer } from '../components/Footer/Footer';
import { SignPost } from '../common/SignPost';

const OurStory = ({
  utmMedium,
  utmCampaign,
}: {
  utmMedium?: string;
  utmCampaign?: string;
}): JSX.Element => (
  <>
    <Meta
      title="Our Story | Second Nature"
      metaDescription="Find out more about the Second Nature team and why we started the company."
      relativeCanonicalURL="/our-story"
    />
    <OurStoryHero
      utmMedium={utmMedium}
      utmCampaign={utmCampaign}
      location="Our story"
    />
    <OurAttitudeToFood />
    <ProgrammeStatistics />
    <WhyWeStarted />
    <WeAreHiring />
    <SignPost version="B" utmMedium={utmMedium} utmCampaign={utmCampaign} />
    <Footer />
  </>
);

export default OurStory;
